export default __webpack_public_path__ + "static/media/фото-127.8ed76e9f.jpg";